module.exports = __webpack_public_path__ + "static/media/solutions-champion.bf457839.jpg";